module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Mono-Bold-028b4acaaaa4b63230b1453120c6a4ba.woff2";